import type { Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { isRejectedWithValue } from "@reduxjs/toolkit";
import authConfig from "@/config/auth";
// import { toast } from "react-toastify";

export const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      // @ts-ignore
       
      if (action.payload.data.message === "Expired JWT Token") {
        localStorage.removeItem(authConfig.storageTokenKeyName);
        // toast.error(LoginErrorMessage);
      }
      // @ts-ignore
       
      if (action.payload.data.message === "Invalid JWT Token") {
        localStorage.removeItem(authConfig.storageTokenKeyName);
        // toast.error(LoginErrorMessage);
      }
    }

    return next(action);
  };
